import { render, staticRenderFns } from "./HelpTerm.vue?vue&type=template&id=786b3090&scoped=true"
var script = {}
import style0 from "./HelpTerm.vue?vue&type=style&index=0&id=786b3090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b3090",
  null
  
)

export default component.exports